'use client';

const negativeBgOnHighEmphasis = ["danger", "upsell"];
function hasDarkBackground({
  variant,
  onDark,
  emphasis
}) {
  if (variant === "primary") return !onDark;
  const isDarkVariant = variant && negativeBgOnHighEmphasis.includes(variant) && emphasis === "high";
  if (isDarkVariant) return !onDark;
  return onDark ?? false;
}
export {
  hasDarkBackground
};
